import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { TranslateService } from '@ngx-translate/core';
import {ActivatedRoute, Router} from "@angular/router";
import { DashboardComponent } from '../dashboard.component';
import { PartnersComponent } from '../partners/partners.component';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {PageEvent} from '@angular/material/paginator';
import {MatChipInputEvent} from '@angular/material/chips';

import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';

import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
   dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'app-taxationreport',
  templateUrl: './taxationreport.component.html',
  styleUrls: ['./taxationreport.component.css'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class TaxationreportComponent implements OnInit {

  Taxation:any;
  Taxations:any[];
  DocumentBodyLoading:boolean;
  loading:boolean;
  ShowCashCollectionContainer:boolean;

  Invoices:any[];
  Filter: {[k: string]: any} = {};
  Totals: any[];
  StockBalanceAdministrations:any[];

  showFilter:boolean;
  partner:any;
  currentPartner:any;
  currentCashCollettion: {[k: string]: any} = {};

  Currencies:any[];
  DocTypes:any[];
  DecimalPrecisions:any[];
  AccountingSeries:any[];
  Administrations:any[];
  MeasuringUnits:any[];
  VATRates:any[];
  ProductGeneralTypes:any[];
  DocumentStatuses:any[];
  Periods:any[];
  Languages:any[];
  PaymentTerms:any[];
  DiscountTypes:any[];
  Agents:any[];
  Countries:any[];
  CashCollectTypes:any[];
  TaxationProductTypes:any[];
  TaxationParents:any;
  Total:any;

  TotalTax:any;
  TotalAfterTax:any;

  ShowProducts:boolean;
  ShowSpendings:boolean;

  InitialTotal:any;
  InsTotal:any;
  OutsTotal:any;
  FinalTotal:any;

  showEditPartnerPopUp:boolean;

  InvoicePrecision:any;

  currency:any;
  newPartnerCountry:any;
  newPartnerBank:any;
  newPartner:any;

  searchTerm:string;
  resultsLength = 0;
  pageSize = 999999;

  Partners:any[];
  countryID:number;
  activeFilters:{[k: string]: any} = [];

  Products:any[];
  CurrentInvoice: {[k: string]: any} = {};

  FromDate = new FormControl(moment());
  ToDate = new FormControl(moment());
  CollectionDate = new FormControl(moment(new Date()));

  showInvoiceVisualizer:boolean;

  constructor(public parent: DashboardComponent, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private route: ActivatedRoute, private router:Router) { 

    translate.addLangs(['en', 'ro', 'de', 'es', 'fr', 'it', 'pl', 'pt']);
    translate.setDefaultLang('en');

    const browserLang = this.parent.getLanguage();
    translate.use(browserLang.match(/en|ro|de|es|fr|it|pl|pt/) ? browserLang : 'en');

  }

  ngOnInit(): void {
    this.showFilter = false;
    this.DocumentBodyLoading = false;
    this.InitializeFilter();
    this.GetInvoiceMasterData();
    this.countryID = null;
    this.ShowProducts = false;
    this.ShowSpendings = false;
  }

  GetPartnersFiltered(searchTerm:string, CountryID:number, resetPaging:boolean){
    var request = {
      SearchTerm:searchTerm,
      CountryID:CountryID,
      PageIndex:1,
      PageSize:this.pageSize,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Company:this.parent.Company
    };

    if(this.searchTerm.length >= 3){
      this.parent.loading = true;

      this.service.GetPartnersFiltered(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
         this.Partners = response["Partners"];
         this.resultsLength = response["Count"];
        }
     
        this.parent.loading = false;
      });
    }
  }

  GetInvoiceMasterData(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    this.service.GetInvoiceMasterData(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Currencies = response["Currencies"];
        this.DecimalPrecisions = response["DecimalPrecisions"];
        this.AccountingSeries = response["AccountingSeries"];
        this.Languages = response["Languages"];
        this.PaymentTerms = response["PaymentTerms"];
        this.Administrations = response["Administrations"];
        this.MeasuringUnits = response["MeasuringUnits"];
        this.VATRates = response["VATRates"];
        this.ProductGeneralTypes = response["ProductGeneralTypes"];
        this.DiscountTypes = response["DiscountTypes"];
        this.Agents = response["Agents"];
        this.DocTypes = response["DocTypes"];
        this.Periods = response["Periods"];
        this.DocumentStatuses = response["DocumentStatuses"];
        this.Countries = response["Countries"];
        this.CashCollectTypes = response["CashCollectTypes"];
        this.currentCashCollettion.Type = this.CashCollectTypes[1];
        this.Taxations = response["Taxations"];
        this.Taxation = this.Taxations[1];

        this.currency = this.Currencies[0];
        this.InvoicePrecision = this.DecimalPrecisions[0];

        this.GetTaxationMasterData();
        this.GetTaxationReport();
      }
   
      this.parent.loading = false;
    });
  }

  GetTaxationMasterData(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    this.service.GetTaxationMasterData(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.TaxationProductTypes = response["TaxationProductTypes"];
      }
   
      this.parent.loading = false;
    });
  }

  InitializeFilter(){

    this.Filter = {};
    this.Filter.FromDate = null;
    this.Filter.ToDate = null;
    this.Filter.Administration = {};
    this.Filter.AccountingSeries = {};
    this.Filter.Product = "";
    this.Filter.Partner = {};
    this.Filter.DocumentNumber = "";
    this.Filter.DocumentStatus = {};
    this.Filter.Period = {};
    this.Filter.Period = null;
    this.Filter.Country = {};
    this.Filter.Country = null;
    this.Filter.Currency = {};
    this.Filter.Currency = null;

    this.Filter.TaxationProductType = {};
    this.Filter.TaxationProductType = null;

    this.Filter.ProductGeneralType = {};
    this.Filter.ProductGeneralType = null;

    this.Filter.DecimalPrecision = {};
    this.Filter.DecimalPrecision = null;

    this.Filter.Pager = {};
    this.Filter.Pager.PageIndex = 1;
    this.Filter.Pager.PageSize = 999999;
    this.Filter.Pager.TotalCount = 0;
  }

  GetInvoicesFiltered(page = 1){

    this.Filter.Pager.PageIndex = page;

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Filter:this.Filter
    };

    if(request.Filter.FromDate != null){
      request.Filter.FromDate = JSON.parse(JSON.stringify(this.FromDate.value._d.toLocaleDateString()));
      this.Filter.FromDate = JSON.parse(JSON.stringify(this.FromDate.value._d.toLocaleDateString()));
    }

    if(request.Filter.ToDate != null){
      request.Filter.ToDate = JSON.parse(JSON.stringify(this.ToDate.value._d.toLocaleDateString()));
      this.Filter.ToDate = JSON.parse(JSON.stringify(this.ToDate.value._d.toLocaleDateString()));
    }
    
    this.loading = true;
    this.showFilter = false;

    this.service.GetInvoicesFiltered(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Invoices = response["Invoices"];
        this.Totals = response["Totals"];

        this.FromDate = new FormControl(moment(this.Filter.FromDate));
        this.ToDate = new FormControl(moment(this.Filter.ToDate));
      }
   
      this.loading = false;
    });

    this.GetInvoicesFilteredCOUNT();
  }

  GetInvoicesFilteredCOUNT(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Filter:this.Filter
    };

    if(request.Filter.FromDate != null){
      request.Filter.FromDate = JSON.parse(JSON.stringify(this.FromDate.value._d.toLocaleDateString()));
      this.Filter.FromDate = JSON.parse(JSON.stringify(this.FromDate.value._d.toLocaleDateString()));
    }

    if(request.Filter.ToDate != null){
      request.Filter.ToDate = JSON.parse(JSON.stringify(this.ToDate.value._d.toLocaleDateString()));
      this.Filter.ToDate = JSON.parse(JSON.stringify(this.ToDate.value._d.toLocaleDateString()));
    }

    this.service.GetInvoicesFilteredCOUNT(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Filter.Pager = response["Pager"];

        this.FromDate = new FormControl(moment(this.Filter.FromDate));
        this.ToDate = new FormControl(moment(this.Filter.ToDate));
      }
   
    });
  }

  ClearPeriod(){
    this.activeFilters = this.activeFilters.filter(x => x.Type != "Period");
    this.Filter.Period = null;

  }

  DisablePeriod(){
    this.Filter.Period = null;
    this.activeFilters = this.activeFilters.filter(x => x.Type != "Period");
  }

  AddActiveFilter(filterName:string, filterType:string){
    var filter = {
      ID:this.parent.newGuid(),
      Name:filterName,
      Type:filterType
    };
    
    if(this.activeFilters.find(x => x.Type == filterType)){
      this.showFilter = false;
      this.GetTaxationReport();
    }

    this.activeFilters = this.activeFilters.filter(x => x.Name != filterName && x.Type != filterType);
    this.activeFilters.push(filter);

    if(filterType == "Period"){
      this.Filter.FromDate = null;
      this.Filter.ToDate = null;

      this.FromDate = new FormControl(moment(this.Filter.FromDate));
      this.ToDate = new FormControl(moment(this.Filter.ToDate));
    }
  }

  RemoveActiveFilter(ID:string, filterType:string){
    this.activeFilters = this.activeFilters.filter(x => x.ID != ID);

    if(filterType == "Administration"){
      this.Filter.Administration = null;
    }
    else if(filterType == "Series"){
      this.Filter.AccountingSeries = null;
    }
    else if(filterType == "DocStatus"){
      this.Filter.DocumentStatus = null;
    }
    else if(filterType == "DocumentNumber"){
      this.Filter.DocumentNumber = null;
    }
    else if(filterType == "Product"){
      this.Filter.Product = null;
    }
    else if(filterType == "Partner"){
      this.Filter.Partner = null;
    }
    else if(filterType == "Period"){
      this.Filter.Period = null;
    }
    else if(filterType == "Country"){
      this.Filter.Country = null;
    }
    else if(filterType == "Currency"){
      this.Filter.Currency = null;
    }
    else if(filterType == "TaxationProductType"){
      this.Filter.TaxationProductType = null;
    }
    else if(filterType == "ProductGeneralType"){
      this.Filter.ProductGeneralType = null;
    }
    else if(filterType == "DecimalPrecision"){
      this.Filter.DecimalPrecision = null;
    }

    this.GetTaxationReport();
}

VizualizeDocument(i:any){
  this.GetInvoice(i, false);
}

FillInvoiceInfo(invoice:any){

  this.partner = {};
  this.CurrentInvoice = invoice;
  this.partner = this.CurrentInvoice.Client;

  this.currency = invoice.Currency;

  if(invoice.Products.length > 0){
    this.InvoicePrecision = invoice.Products[0].ProductInvoiceInfo.DecimalPrecision;
  }

  this.Products = invoice.Products;
}

GetInvoice(id:string, UseInvoiceLanguage:boolean){

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    ID:id,
    WithInfo:true,
    UseInvoiceLanguage:UseInvoiceLanguage
  };

  this.service.GetInvoice(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.FillInvoiceInfo(response["Invoice"]);
      this.showInvoiceVisualizer = true;
    }
  });
}

PrintInvoice(i:any){

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    InvoiceID:i.ID,
  };

  this.DocumentBodyLoading = true;

  this.service.ExportInvoice(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      var Document = response["Document"];
      this.printPage(Document.Name , Document.PDFStream, Document.ID);
    }

    this.DocumentBodyLoading = false;
  });
}

download(filename, text) {
  var element = document.createElement('a');
  element.setAttribute('href', 'data:application/pdf;base64,' + encodeURIComponent(text));
  element.setAttribute('download', filename);

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}

ExportInvoice(i:any){

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    InvoiceID:i.ID,
  };

  this.DocumentBodyLoading = true;

  this.service.ExportInvoice(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      var Document = response["Document"];
      this.download(Document.Name, Document.PDFStream);
    }

    this.DocumentBodyLoading = false;
  });
}

printPage(name:string, html:string, ID:string) {
  var winparams = 'dependent=yes,locationbar=no,scrollbars=yes,menubar=yes,' +
  'resizable,screenX=50,screenY=50,width=850,height=1050';

var htmlPop = '<embed width=100% height=100%'
  + ' type="application/pdf"'
  + ' src="data:application/pdf;base64,'
  + escape(html)
  + '"></embed>';

var newWindow = window.open("", 'PDF_' + name +"_"+ ID);
newWindow.document.write(htmlPop);
};

ViewInvoice(i:any){
  this.router.navigate(['/dashboard/sales/invoice'], { queryParams: { id: i.ID, user: this.parent.User.Id } }); 
}

DeleteInvoice(invoice:any){

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    InvoiceID:invoice.ID,
    DetailsID:invoice.Details.ID,
    AccountingNumber:invoice.AccountingNumber
  };

  this.loading = true;

  this.service.DeleteInvoice(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
     this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
     this.GetInvoicesFiltered();
     this.showInvoiceVisualizer = false;
    }

    this.loading = false;
  });

}

CancelOrActivate(InvoiceID:string,CancelInvoice:boolean){

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    InvoiceID:InvoiceID,
    CancelInvoice:CancelInvoice,
  };

  this.loading = true;

  this.service.CancelOrActivate(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
     this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
     this.GetInvoicesFiltered();
    }

    this.loading = false;

  });

}

initializePartnerFormFromObject(partner:any){

  this.currentPartner = new FormGroup({

    VAT:new FormControl(partner.VAT),
    UPN:new FormControl(partner.UPN),
    Name:new FormControl(partner.Name, [Validators.required]),
    COCRegNumber:new FormControl(partner.COCRegNumber),

    TaxPayer:new FormControl(partner.TaxPayer),

    Country:new FormControl(partner.BillingAddress.Country),
    StateProvince:new FormControl(partner.BillingAddress.StateProvince, [Validators.required]),
    City:new FormControl(partner.BillingAddress.City, [Validators.required]),
    AddressLine:new FormControl(partner.BillingAddress.AddressLine, [Validators.required]),

    Bank:new FormControl(partner.Bank),
    BankAccount:new FormControl(partner.Bank.BankAccount),

    Email: new FormControl(partner.ContactInfo.Email, [Validators.email]),
    ContactName:new FormControl(partner.ContactInfo.Name),
    Phone:new FormControl(partner.ContactInfo.Phone),
  });
 
  this.showEditPartnerPopUp = true;
  this.partner = partner;
}

UpdatePartner(){
  var request = {
    Partner:{
      ID:String,
      VAT:this.currentPartner.controls['VAT'].value,
      UPN:this.currentPartner.controls['UPN'].value,
      Name:this.currentPartner.controls['Name'].value,
      COCRegNumber:this.currentPartner.controls['COCRegNumber'].value,

      TaxPayer:this.currentPartner.controls['TaxPayer'].value,

      BillingAddress:{
        ID:Number,
        Country:this.currentPartner.controls['Country'].value,
        StateProvince:this.currentPartner.controls['StateProvince'].value,
        City:this.currentPartner.controls['City'].value,
        AddressLine:this.currentPartner.controls['AddressLine'].value,
      },
      Bank:this.currentPartner.controls['Bank'].value,
      ContactInfo:{
        ID:Number,
        Email:this.currentPartner.controls['Email'].value,
        Name:this.currentPartner.controls['ContactName'].value,
        Phone:this.currentPartner.controls['Phone'].value,
      },
      Company:this.parent.Company,
      EUVATVerified:this.partner.EUVATVerified,
    },
    User:this.parent.User,
    Language:this.parent.getLanguage()
  };

  request.Partner.Bank.BankAccount = this.currentPartner.controls['BankAccount'].value;
  request.Partner.ID = this.partner.ID;
  request.Partner.BillingAddress.ID = this.partner.BillingAddress.ID;
  request.Partner.ContactInfo.ID = this.partner.ContactInfo.ID;

  this.parent.loading = true;

  this.service.UpdatePartner(request).subscribe(response => {
 
    if(response["Status"] != 1){
    
    }
    else if(response["Status"] == 1){
     this.showEditPartnerPopUp = false;
     this.parent.openSnackBar("Partner Updated", "OK", "light-info-snackbar");
     this.partner = response["Partner"];
    }
 
    this.parent.loading = false;
  });
}

compareFn(c1: any, c2: any): boolean {
  return c1 && c2 ? c1.ID === c2.ID : c1 === c2;
}

GenerateNewInvoice(i:any, storno:boolean, newCopy:boolean){
  this.router.navigate(['/dashboard/sales/invoice'], { queryParams: { id: i.ID, IsStorno: storno, NewCopy:newCopy } }); 
}

InitializeNewCashCollection(i:any){
  this.ShowCashCollectionContainer = true; 
  this.CurrentInvoice = i;
  this.currentCashCollettion = {};
  this.currentCashCollettion.Type = this.CashCollectTypes[1];
  this.currentCashCollettion.Currency = this.CurrentInvoice.Currency;
}

AddCashCollection(){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    CashCollect:this.currentCashCollettion,
    InvoiceDetailsID:this.CurrentInvoice.Details.ID
  };

  if(this.CollectionDate.value != null){
    request.CashCollect.CollectionDate = JSON.parse(JSON.stringify(this.CollectionDate.value._d.toLocaleDateString()));
    this.CollectionDate = JSON.parse(JSON.stringify(this.CollectionDate.value._d.toLocaleDateString()));
  }

  this.parent.loading = true;

  this.service.AddCashCollection(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
    }

    this.CollectionDate = new FormControl(moment());
    this.parent.loading = false;
  });
}

GetVATReport(){
  this.Filter.Pager.PageIndex = 1;

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Filter:this.Filter
    };

    if(request.Filter.FromDate != null){
      request.Filter.FromDate = JSON.parse(JSON.stringify(this.FromDate.value._d.toLocaleDateString()));
      this.Filter.FromDate = JSON.parse(JSON.stringify(this.FromDate.value._d.toLocaleDateString()));
    }

    if(request.Filter.ToDate != null){
      request.Filter.ToDate = JSON.parse(JSON.stringify(this.ToDate.value._d.toLocaleDateString()));
      this.Filter.ToDate = JSON.parse(JSON.stringify(this.ToDate.value._d.toLocaleDateString()));
    }
    
    this.loading = true;
    this.showFilter = false;

    this.service.GetVATReport(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.FromDate = new FormControl(moment(this.Filter.FromDate));
        this.ToDate = new FormControl(moment(this.Filter.ToDate));
      }
   
      this.loading = false;
    });
}

GetTaxationReport(page = 1){
  this.Filter.Pager.PageIndex = page;

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Filter:this.Filter,
      Taxation:this.Taxation
    };

    if(request.Filter.FromDate != null){
      request.Filter.FromDate = JSON.parse(JSON.stringify(this.FromDate.value._d.toLocaleDateString()));
      this.Filter.FromDate = JSON.parse(JSON.stringify(this.FromDate.value._d.toLocaleDateString()));
    }

    if(request.Filter.ToDate != null){
      request.Filter.ToDate = JSON.parse(JSON.stringify(this.ToDate.value._d.toLocaleDateString()));
      this.Filter.ToDate = JSON.parse(JSON.stringify(this.ToDate.value._d.toLocaleDateString()));
    }
    
    this.loading = true;
    this.showFilter = false;

    this.service.GetTaxationReport(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.FromDate = new FormControl(moment(this.Filter.FromDate));
        this.ToDate = new FormControl(moment(this.Filter.ToDate));
        this.TaxationParents = response["TaxationParents"];
        this.Total = response["Total"];

        this.TotalTax = response["TotalTax"];
        this.TotalAfterTax = response["TotalAfterTax"];
      }
  
      this.loading = false;
    });
}

GetTaxationReportElements(c:any, ParentID:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ContentType:c,
      Filter:this.Filter,
    };

    this.service.GetTaxationReportElements(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.TaxationParents.forEach(element => {
          if(element.UIID == ParentID){
            element.TaxationProducts = response["TaxationProducts"];
            element.IsLoading = false;
          }
        });
      }
    });
}

GetStockBalanceTotalValues(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Filter:this.Filter
    };

    if(request.Filter.FromDate != null){
      request.Filter.FromDate = JSON.parse(JSON.stringify(this.FromDate.value._d.toLocaleDateString()));
      this.Filter.FromDate = JSON.parse(JSON.stringify(this.FromDate.value._d.toLocaleDateString()));
    }

    if(request.Filter.ToDate != null){
      request.Filter.ToDate = JSON.parse(JSON.stringify(this.ToDate.value._d.toLocaleDateString()));
      this.Filter.ToDate = JSON.parse(JSON.stringify(this.ToDate.value._d.toLocaleDateString()));
    }
    
    this.loading = true;
    this.showFilter = false;

    this.service.GetStockBalanceTotalValues(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.FromDate = new FormControl(moment(this.Filter.FromDate));
        this.ToDate = new FormControl(moment(this.Filter.ToDate));

        this.InitialTotal = response["InitialTotal"];
        this.InsTotal = response["InsTotal"];
        this.OutsTotal = response["OutsTotal"];
        this.FinalTotal = response["FinalTotal"];
      }
   
      this.loading = false;
    });
}

GetStockBalanceCOUNT(){

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Filter:this.Filter
  };

  if(request.Filter.FromDate != null){
    request.Filter.FromDate = JSON.parse(JSON.stringify(this.FromDate.value._d.toLocaleDateString()));
    this.Filter.FromDate = JSON.parse(JSON.stringify(this.FromDate.value._d.toLocaleDateString()));
  }

  if(request.Filter.ToDate != null){
    request.Filter.ToDate = JSON.parse(JSON.stringify(this.ToDate.value._d.toLocaleDateString()));
    this.Filter.ToDate = JSON.parse(JSON.stringify(this.ToDate.value._d.toLocaleDateString()));
  }

  this.service.GetStockBalanceCOUNT(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.Filter.Pager = response["Pager"];

      this.FromDate = new FormControl(moment(this.Filter.FromDate));
      this.ToDate = new FormControl(moment(this.Filter.ToDate));
    }
 
  });
}

ExportStockBalanceValues(){

  this.Filter.Pager.PageIndex = 1;

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Filter:this.Filter
    };

    if(request.Filter.FromDate != null){
      request.Filter.FromDate = JSON.parse(JSON.stringify(this.FromDate.value._d.toLocaleDateString()));
      this.Filter.FromDate = JSON.parse(JSON.stringify(this.FromDate.value._d.toLocaleDateString()));
    }

    if(request.Filter.ToDate != null){
      request.Filter.ToDate = JSON.parse(JSON.stringify(this.ToDate.value._d.toLocaleDateString()));
      this.Filter.ToDate = JSON.parse(JSON.stringify(this.ToDate.value._d.toLocaleDateString()));
    }
    
    this.parent.loading = true;
    this.showFilter = false;

    this.service.ExportStockBalanceValues(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        var Document = response["Document"];
      this.download(Document.Name, Document.PDFStream);
      }
   
      this.parent.loading = false;
    });
}

ShowProductHistoryEventsContainer:boolean;
ProductEvents:any[];
auxProduct:any;

GetProductHistoryEvents(p:any){
  var request = {
    ProductID:p.ProductID,
    User:this.parent.User,
    Language:this.parent.getLanguage(),
  };

    this.auxProduct = JSON.parse(JSON.stringify(p));
    this.parent.loading = true;

    this.service.GetProductHistoryEvents(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.ProductEvents = response["Events"];
        this.ShowProductHistoryEventsContainer = true;
      }
   
      this.parent.loading = false;
    });
}

}
